import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ProgramaRepasseBndes } from "src/app/model/programas-permitidos.model";
import { ProgramasPermtidosPorCestasService } from "../programas-permitidos-por-cestas.service";

@Component({
  selector: 'app-programas-permitidos-por-cestas-edicao',
  templateUrl: 'programas-permitidos-por-cestas-edicao.component.html',
  standalone: false
})
export class ProgramasPermitidosPorCestasEdicaoComponent implements OnInit {

  public programa: ProgramaRepasseBndes;
  public ideTranche: number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private service: ProgramasPermtidosPorCestasService,
              private messageService: MessageChannelService) {

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as { programa: ProgramaRepasseBndes, ideTranche: number };
    if (state) {
      this.programa = state.programa;
      this.ideTranche = state.ideTranche;
    }
  }

  ngOnInit() {
    if (!this.programa) {
      this.voltar();
    }
  }

  get codigoFormatado(): string {
    return ('000000' + this.programa.id).slice(-6);
  }

  salvar() {
    const dto = {
      id: this.programa.id,
      aceitaBeneficiarioCpfRepasse: this.programa.aceitaBeneficiarioCpfRepasse,
      desconsiderarPrazoTotalMaximoContratual: this.programa.desconsiderarPrazoTotalMaximoContratual
    };

    this.service.editarRepasse(this.ideTranche, this.programa.id, dto).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Programa atualizado com sucesso'
      });
      this.voltar();
    });
  }

  voltar() {
    this.router.navigate(['programas-permitidos-por-cestas']);
  }
}
